import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { DateTimeString, IApiResponse } from 'county-api/responses';
import { environment } from 'src/environments/environment';
import { BranchDayFleetSiteCheck as BranchDayFleetSiteCheckDto, BranchSchedule, GlobalBranchDayFleetSiteCheck as GlobalBranchDayFleetSiteCheckDto } from './branch-day-fleet-site-check';
import { PerformanceDataService } from 'src/app/dashboard/perfomance/performance-data.service';

@Component({
    selector: 'closing-check-overview',
    templateUrl: './closing-check-overview.component.html',
    styleUrls: ['./closing-check-overview.component.css'],
})
export class ClosingChecksComponent implements OnInit {
    

    private readonly locations = [
        "Stockport",
        "Chester",
        "Preston",
        "Oldham"
    ];

    private readonly NoSiteCheckFoundStatus = -1;
    private readonly ErrorOnRetrievingSiteCheckStatus = -2;
    private readonly SuccessfulCheckStatus = 2;
    private readonly PendingCheckOneStatus = 1;
    private readonly PendingCheckTwoOrThreeStatus = 0;
    private readonly UnableToDetermineCheckStatus = 3;
    private readonly CheckOneFailedStatus = 0;
    private readonly CheckTwoOrThreeFailedStatus = 1;
    readonly LastRefreshedTime: string;

    constructor(
            private authService: MsalService,
            private httpservice: HttpClient,
        ) {
            this.LastRefreshedTime = new Date().toTimeString();
        }
    ngOnInit(): void {
        this.loadInitialData();
    }

    dateToactiveBranchesMap: Map<string, BranchSchedule[]> = new Map<string, BranchSchedule[]>();
    datebranchSiteChecks: Map<string, BranchDayFleetSiteCheckDto[]> = new Map<string, BranchDayFleetSiteCheckDto[]>();
    lastNDaysOfData = 7;

    lastUploadDate: string = "";


    async loadInitialData(){
        this.branchSiteCheckDownload(new Date());
    }

    isSameColour(maps: {
        cssClass: string;
        status: string;
    }[]){
        const cssClasses = maps.map(x => x.cssClass);

        const distinctClasses = [...new Set(cssClasses)];

        return distinctClasses.length == 1;
    }

   areAllBranchesSameColour(branches: BranchDayFleetSiteCheckDto[]): boolean{
        const maps = this.locations.map(x => this.getLocationSiteCheckStatuses(x, branches));
        return this.isSameColour(maps.flatMap(x => x));
   }

   // returns a css class that is used to update that day row into a single one-colour bar
   getUpperMostRowUnityCssClass(dateKey: string){
    // if all branches have same colour, return unity class, otherwise return nothing
        const dateBranches = this.datebranchSiteChecks.get(dateKey);
        const branchesHaveSameColour = this.areAllBranchesSameColour(dateBranches);
        if (branchesHaveSameColour){
            return "uppermost-row-day-merged";
        }

        return "";
   }

   // returns a css class that is used to update that day branch column into a single one-colour bar
   getdayBranchUnityCssClass(dateKey: string){
    // if all branches have same colour, return unity class, otherwise return nothing
        const dateBranches = this.datebranchSiteChecks.get(dateKey);
        const branchesHaveSameColour = this.areAllBranchesSameColour(dateBranches);
        if (branchesHaveSameColour){
            return "day-branch-day-merged";
        }

        return "";
   }

   // returns a css class that is used to update that day branch column into a single one-colour bar
   getdayGlobalBranchUnityCssClass(dateKey: string){
    // if all branches have same colour, return unity class, otherwise return nothing
        const dateBranches = this.datebranchSiteChecks.get(dateKey);
        const branchesHaveSameColour = this.areAllBranchesSameColour(dateBranches);
        if (branchesHaveSameColour){
            return "global-day-branch-day-merged";
        }

        return "";
   }

    getLocationSiteCheckStatuses(location: string, siteChecks: BranchDayFleetSiteCheckDto[]){
        const targetSiteCheck = this.getSiteCheckByLocation(location, siteChecks);
        return this.getBranchSiteCheckStatuses(targetSiteCheck);
    }

     getBranchSiteCheckStatuses(targetSiteCheck: BranchDayFleetSiteCheckDto | null | undefined){
        if (!targetSiteCheck){
            return [
                {
                    cssClass: this.mapCheckStatusToColourCssClass(this.NoSiteCheckFoundStatus), 
                    status: this.mapCheckOneStatus(this.NoSiteCheckFoundStatus)
                }, 
                {
                    cssClass: this.mapCheckStatusToColourCssClass(this.NoSiteCheckFoundStatus), 
                    status: this.mapCheckTwoStatus(this.NoSiteCheckFoundStatus)
                },                 
                {
                    cssClass: this.mapCheckStatusToColourCssClass(this.NoSiteCheckFoundStatus), 
                    status: this.mapCheckThreeStatus(this.NoSiteCheckFoundStatus)
                },             
            ];
        }

        return this.getSiteCheckStatuses(targetSiteCheck.check_one_status, targetSiteCheck.check_two_status, targetSiteCheck.check_three_status);
    }

    getSiteCheckStatuses(siteCheckOneStatus: number, siteCheckTwoStatus: number, siteCheckThreeStatus: number){
        return [
                {
                    cssClass: this.mapCheckStatusToColourCssClass(siteCheckOneStatus, siteCheckOneStatus == 1 ? "Pending" : null), 
                    status: this.mapCheckOneStatus(siteCheckOneStatus)
                },
                {
                    cssClass: this.mapCheckStatusToColourCssClass(siteCheckTwoStatus, siteCheckTwoStatus == 0 ? "Pending" : null), 
                    status: this.mapCheckTwoStatus(siteCheckTwoStatus)
                },
                {
                    cssClass: this.mapCheckStatusToColourCssClass(siteCheckThreeStatus, siteCheckThreeStatus == 0 ? "Pending" : null), 
                    status: this.mapCheckThreeStatus(siteCheckThreeStatus)
                }
        ];
    }

    
    

    branchSiteCheckDownload(date: Date) {
            const account = this.authService.instance.getAllAccounts()[0];
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
               };
    
            this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
                const accessToken = x.accessToken;

                this.retrieveLastAmcImportDate(accessToken).subscribe(
                    x => {
                        this.lastUploadDate = x.result;
                    }
                );
                
                for (var times = 0; times < this.lastNDaysOfData; times++){
                    var requestedDate = new Date(date);
                    requestedDate.setDate(requestedDate.getDate() - times);

                    const year = requestedDate.getFullYear();
                    const month = requestedDate.getMonth() + 1;
                    const day = requestedDate.getDate();

                    this.retrieveActiveBranches(accessToken, year, month, day).subscribe(
                        response => {
                            this.onActiveBranchesReceived(year, month, day, response);
                        }
                    );

                    this.retrieveBranchSiteChecks(accessToken, year, month, day).subscribe(response => {
                        this.onBranchSiteCheckDownloaded(year, month, day, response);
                        
                     }, (response: any) => {
                        const noMatchFound = response != null && response?.error?.result?.includes("No match found"); 
                        if(noMatchFound){
                            this.onNoMatchFound(year, month, day);
                        }
                        else{
                            this.onUnexpectedRetrievalError(year, month, day);
                        }
                     });
                }
            });  
        };

    retrieveActiveBranches(accessToken: string, year: number, month: number, day: number){

        const url = environment.apiUrl + `api/v2/branchschedules/Active?year=${year}&month=${month}&day=${day}`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }

    retrieveBranchSiteChecks(accessToken: string, year: number, month: number, day: number){

        const url = environment.apiUrl + `api/v2/closingchecks/GetBranchSiteSiteChecksForAllLocations?year=${year}&month=${month}&day=${day}`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }

    retrieveLastAmcImportDate(accessToken: string){

        const url = environment.apiUrl + `api/v2/closingchecks/LatestAmcImportDate`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }

    onActiveBranchesReceived(year: number, month: number, day: number, response: IApiResponse<BranchSchedule[]>){
        if (!response.result){
            return;
        }

        const key = `${year}-${month}-${day}`;
        this.dateToactiveBranchesMap.set(key, response.result);
    }

    onBranchSiteCheckDownloaded(year: number, month: number, day: number, data: IApiResponse<BranchDayFleetSiteCheckDto[]>){
        const key = `${year}-${month}-${day}`;
        this.datebranchSiteChecks.set(key, data.result);
    }

    onDateChanged(dateString: string){
        if (!dateString){
            return;
        }

        const date = new Date(dateString);
        
        this.datebranchSiteChecks.clear();

        this.branchSiteCheckDownload(date);
    }

    generateCustomStatusSiteCheck(location: string, siteCheckDate: Date, customStatus: number): BranchDayFleetSiteCheckDto{
        return {
            id: '',
            check_one_status: customStatus,
            check_two_status: customStatus,
            check_three_status: customStatus,
            last_updated_time: '',
            location: location,
            site_check_date: siteCheckDate
        };
    }

    onNoMatchFound(year: number, month: number, day: number){
        const key = `${year}-${month}-${day}`;

        const noMatchFoundPlaceholderSiteChecks = this.locations.map(x => this.generateCustomStatusSiteCheck(x, new Date(year, month, day), this.NoSiteCheckFoundStatus));
        this.datebranchSiteChecks.set(key, noMatchFoundPlaceholderSiteChecks);
    }

    onUnexpectedRetrievalError(year: number, month: number, day: number){
        const key = `${year}-${month}-${day}`;

        const errorRetrievalPlaceholderSiteChecks = this.locations.map(x => this.generateCustomStatusSiteCheck(x, new Date(year, month, day), this.ErrorOnRetrievingSiteCheckStatus));
        this.datebranchSiteChecks.set(key, errorRetrievalPlaceholderSiteChecks);
    }

    getDateBranchKeyYear(key: string){
        return key.split("-")[0];
    }

    getDateBranchKeyMonth(key: string){
        return key.split("-")[1];
    }

    getDateBranchKeyDay(key: string){
        return key.split("-")[2];
    }

    formatDateTime(date: string){
        const fmt = new Intl.DateTimeFormat("en-GB", { 
            year: "numeric", 
            month: "2-digit", 
            day: "2-digit", 
            hour: "2-digit", 
            minute: "2-digit", 
            second: "2-digit", 
            hour12: false }
        );

        return fmt.format(new Date(date)).replace(",", "");
    }

    mapCheckOneStatus(value: number) {
        const patterns = new Map<number, string> ([
            [this.ErrorOnRetrievingSiteCheckStatus, "Error Retrieving Data"],
            [this.NoSiteCheckFoundStatus, "No Data Found"],
            [this.CheckOneFailedStatus, "Vehicles Missing"],
            [this.PendingCheckOneStatus, "Pending"],
            [this.SuccessfulCheckStatus, "All Vehicles Present"],
            [this.UnableToDetermineCheckStatus, "Unable to Determine Status"],
        ]);

        return patterns.get(value) ?? "Undefined status";
    };

    mapCheckTwoStatus(value: number) {
        const patterns = new Map<number, string> ([
            [this.ErrorOnRetrievingSiteCheckStatus, "Error Retrieving Data"],
            [this.NoSiteCheckFoundStatus, "No Data Found"],
            [this.PendingCheckTwoOrThreeStatus, "Pending"],
            [this.CheckTwoOrThreeFailedStatus, "Keys Missing"],
            [this.SuccessfulCheckStatus, "All Vehicle Keys Present"],
            [this.UnableToDetermineCheckStatus, "Unable to Determine Status"],
        ]);

        return patterns.get(value) ?? "Undefined status";
    };

    mapCheckThreeStatus(value: number) {
        const patterns = new Map<number, string> ([
            [this.ErrorOnRetrievingSiteCheckStatus, "Error Retrieving Data"],
            [this.NoSiteCheckFoundStatus, "No Data Found"],
            [this.PendingCheckTwoOrThreeStatus, "Pending"],
            [this.CheckTwoOrThreeFailedStatus, "Some Vehicles Not Locked"],
            [this.SuccessfulCheckStatus, "All Vehicles Locked"],
            [this.UnableToDetermineCheckStatus, "Unable to Determine Status"],
        ]);

        return patterns.get(value) ?? "Undefined status";
    };

    mapCheckStatusToColourCssClass(value: number, status: string | null | undefined = null){
        if (status == "Pending"){
            return "pending-status";
        }

        return this.mapCheckStatusValueToColourCssClass(value);
    }

    mapCheckStatusValueToColourCssClass(value: number) {
        const patterns = new Map<number, string> ([
            [this.ErrorOnRetrievingSiteCheckStatus, "error-retrieving-status"],
            [this.NoSiteCheckFoundStatus, "no-site-check-found-status"],
            [1, "check-failed"], //this applies to checks 2 and 3 but for one where 1 means pending
            [this.SuccessfulCheckStatus, "check-successful"],
            [this.UnableToDetermineCheckStatus, "unable-determine-status"],
        ]);

        return patterns.get(value) ?? "unable-determine-status";
    };

    getSiteCheckByLocation(location: string, siteChecks: BranchDayFleetSiteCheckDto[]): BranchDayFleetSiteCheckDto | undefined {
        return siteChecks.find(x => x.location === location);
    }

    calculateGlobalCheckOne(checkOneStatuses: number[]){
        if (checkOneStatuses.every(x => x == this.SuccessfulCheckStatus)){
            return this.SuccessfulCheckStatus;
        }
        if (checkOneStatuses.every(x => x == this.NoSiteCheckFoundStatus)){
            return this.NoSiteCheckFoundStatus;
        }
        if (checkOneStatuses.filter(x => x == this.PendingCheckOneStatus).length > 0){
            return this.PendingCheckOneStatus;
        }
        if (checkOneStatuses.filter(x => x == this.CheckOneFailedStatus).length > 0){
            return this.CheckOneFailedStatus;
        }

        return this.UnableToDetermineCheckStatus;
    }

    calculateGlobalCheck(checkTwoStatuses: number[]){
        if (checkTwoStatuses.every(x => x == this.SuccessfulCheckStatus)){
            return this.SuccessfulCheckStatus;
        }
        if (checkTwoStatuses.every(x => x == this.NoSiteCheckFoundStatus)){
            return this.NoSiteCheckFoundStatus;
        }
        if (checkTwoStatuses.filter(x => x == this.PendingCheckTwoOrThreeStatus).length > 0){
            return this.PendingCheckTwoOrThreeStatus;
        }
        if (checkTwoStatuses.filter(x => x == this.CheckTwoOrThreeFailedStatus).length > 0){
            return this.CheckTwoOrThreeFailedStatus;
        }

        return this.UnableToDetermineCheckStatus;
    }

    getGlobalSiteCheck(siteChecks: BranchDayFleetSiteCheckDto[], dateString: string): GlobalBranchDayFleetSiteCheckDto | null {
        if (siteChecks.length != 4){
            return {
                check_one_status: this.NoSiteCheckFoundStatus,
                check_two_status: this.NoSiteCheckFoundStatus,
                check_three_status: this.NoSiteCheckFoundStatus,
                site_check_date: new Date(dateString),
            } as GlobalBranchDayFleetSiteCheckDto;
        }

        const firstSiteCheck = siteChecks[0];

        var globalSiteCheck: GlobalBranchDayFleetSiteCheckDto = {
            check_one_status: this.calculateGlobalCheckOne(siteChecks.map(x => x.check_one_status)),
            check_two_status: this.calculateGlobalCheckOne(siteChecks.map(x => x.check_two_status)),
            check_three_status: this.calculateGlobalCheckOne(siteChecks.map(x => x.check_three_status)),
            site_check_date: firstSiteCheck.site_check_date
        };

        return globalSiteCheck;
    }

}
